import { IndexTable, Text } from '@shopify/polaris';

const DeliveryStockTableClosed = ({ product, hasTotal = false }) => {
  const headings = [{ title: '' }, ...product.variants.map((v) => ({ title: v.title })), { title: 'TOTAL' }] || [];

  const generateStock = (mapFn) =>
    product.variants
      .map((v) => {
        const Sqty = product.stock.find((s) => v.barcode === s.barcode);
        return Sqty ? Sqty : { qty: 0, qtyExpected: 0 };
      })
      .map(mapFn);

  const rowMarkup = [
    {
      label: 'Esperado',
      stock: generateStock(({ qtyExpected }) => qtyExpected),
    },
    { label: 'Entregado', stock: generateStock(({ qty }) => qty) },
    { label: 'Diferencia', stock: generateStock(({ qty, qtyExpected }) => qty - qtyExpected) },
  ]
    .map((d) => [d.label, ...d.stock, d.stock.reduce((acc, cur) => acc + cur, 0)])
    .map((row, index) => (
      <IndexTable.Row id={index} key={index} position={index} subdued selected={false}>
        {row.map((cell, i, arr) => (
          <IndexTable.Cell key={i}>
            <Text
              alignment={i ? 'center' : 'start'}
              variant="headingXs"
              fontWeight={!(i % row.length) || !((i + 1) % row.length) ? 'bold' : 'regular'}
            >
              {cell}
            </Text>
          </IndexTable.Cell>
        ))}
      </IndexTable.Row>
    ));

  rowMarkup.length > 1 &&
    hasTotal &&
    rowMarkup.push(
      <IndexTable.Row id={rowMarkup.length} key={rowMarkup.length} position={rowMarkup.length} disabled>
        <IndexTable.Cell>
          <Text alignment="start" fontWeight="bold">
            TOTAL
          </Text>
        </IndexTable.Cell>
        {product.variants.map((v, index) => (
          <IndexTable.Cell key={index}>
            <Text alignment="center" fontWeight="bold">
              {product.stock.filter((s) => s.barcode === v.barcode).reduce((acc, cur) => acc + cur.qty, 0)}
            </Text>
          </IndexTable.Cell>
        ))}
        <IndexTable.Cell>
          <Text alignment="center" fontWeight="bold">
            {product.stock.reduce((acc, cur) => acc + cur.qty, 0)}
          </Text>
        </IndexTable.Cell>
      </IndexTable.Row>,
    );

  return (
    <IndexTable headings={headings} itemCount={rowMarkup.length} selectable={false} lastColumnSticky={true}>
      {rowMarkup}
    </IndexTable>
  );
};

export default DeliveryStockTableClosed;
